import Footer, { MobileFooter } from '~/components/Modal/Footer/Footer';

export { MobileFooter };
export default Footer;
